import { createSelector } from 'reselect'
import { isUnread } from '../utils/state'
import { selectCurrentConversation } from './selectCurrentConversation'

export const selectCurrentConversationIsUnread = createSelector(
  selectCurrentConversation,
  isUnread
)
